// EffectColors - visual color mapping for ongoing effects
// date_of_change: 2025-10-25
// rule_reference: Visual feedback rings for ongoing effects (Bless, Bane, Invisibility)

const EffectColors = {
  // base palette
  cream: '#F5F1E8',
  yellow: '#F7D154',
  green: '#4CAF50',
  blue: '#4FC3F7',
  pink: '#F48FB1',
  purple: '#B39DDB',
  brown: '#8D6E63',
  red: '#EF5350',
  orange: '#FFA726',

  // defaults for common effects
  byEffect: {
    bless: 'yellow',
    bane: 'purple',
    invisibility: 'blue',
    concentrating: 'orange',
  }
};

export default EffectColors;
